module.exports = "/images/vendor/flag-icon-css/flags/4x3/qa.svg?b314986b75f2a81f557544f73e2cd203";